import { IMode } from '../../ts/interface/mode.interface';
import { connect } from 'react-redux';
import { ISystem } from '../../ts/interface/system.interface';
import PageContainer from '../../components/Redesing/page-container';
import RentalsTableCard from '../../components/Redesing/table/rental/rentals-table-card';
import useOrganization from '../../hooks/use-organization';

const Rentals = ({ systemLoaded }: { systemLoaded: boolean }) => {
  const organizationInfo = useOrganization();

  const isLoading = Boolean(organizationInfo?.id) ? false : !systemLoaded;

  return (
    <PageContainer isLoading={isLoading} spaceName={'Rentals'}>
      <RentalsTableCard
        noRentalsText={'No rentals available'}
        parameters={
          organizationInfo?.id
            ? { organization_id: organizationInfo.id }
            : undefined
        }
      />
    </PageContainer>
  );
};

const RentalsR = connect(
  (state: { system: ISystem; mode: IMode }) => ({
    modeInfo: state.mode,
    systemLoaded: state.system.isLoaded,
  }),
  () => ({})
)(Rentals);

export default RentalsR;
